import styled from '@emotion/styled'

interface HtmlIframeProps {
  height?: number
  isLoading?: boolean
  isSafari?: boolean
  zoom?: number
}

export const HtmlIframe = styled.iframe<HtmlIframeProps>`
  width: 210mm;
  height: ${({ height }) => (typeof height === 'number' ? `${height}px` : '100%')};
  pointer-events: none;
  /* In Safari CSS 'zoom' scales the iframe container but not the inner HTML scaled via script-applied 'transform', */
  /* which causes right-side cropping. Setting 'zoom' only for non-Safari browsers to avoid this issue. */
  ${({ zoom, isSafari }) => zoom !== undefined && !isSafari && `zoom: ${zoom};`}

  ${({ isLoading }) => {
    if (isLoading) {
      return `
        visibility: hidden;
      `
    }
  }};
`
